import type { PrivilegeModel } from '../models.ts'
import { AllPermissions } from '../types/permissions.ts'

// Note: These Core, Brand, Agency, and Internal privileges are legacy placeholders used to maintain parity with the previous access-control model.
// Going forward, these will be replaced with more descriptive, persona-driven and possibly reusable fragments, breaking them into finer-grained and modular privileges.
// The idea around privileges are logical groups of permissions that make sense together. This helps prevent incomplete or roles that don't make sense.

export const CorePrivilege: PrivilegeModel = {
  name: 'Core',
  key: 'core',
  permissions: [
    'activity:create',
    'activity:view',
    'file:upload',
    'project:view',
    'own-team-profile:update',
  ],
}

export const OrganizationAdminPrivilege: PrivilegeModel = {
  name: 'Organization Admin',
  key: 'organization-admin',
  permissions: [
    'own-organization:administer',
    'own-organization-team:administer',
    'own-organization-user:administer',
    'own-team:administer',
    'own-team-user:administer',
  ],
}

export const BrandPrivilege: PrivilegeModel = {
  name: 'Brand',
  key: 'brand',
  permissions: [
    'cost-plus-margin:view',
    'internal-pricing-note:view',
    'project:archive',
    'project:comment',
    'project:create',
    'project:duplicate',
    'project:delete',
    'project:edit',
    'project:submit',
    'review-feedback:update',
    'brand:view',
    'package:view',
  ],
}

export const AgencyPrivilege: PrivilegeModel = {
  name: 'Agency',
  key: 'agency',
  permissions: [
    'bid:create',
    'cost:view',
    'project:comment',
    'project:complete',
    'review-proposal:update',
    'agency:edit',
    'agency:view',
  ],
}

export const InternalPrivilege: PrivilegeModel = {
  name: 'Internal',
  key: 'internal',
  permissions: [
    'cost:view',
    'cost-plus-margin:view',
    'internal-pricing-note:view',
    'package:administer',
    'package:view',
    'project:administer',
    'project:create',
    'project:complete',
    'project:edit',
    'project:submit',
    'match:edit',
    'match:remove',
    'match:view',
    'customer-organization:administer',
    'customer-team:administer',
    'customer-user:administer',
    'agency:edit',
    'agency:view',
    'brand:view',
  ],
}

export const AllPrivilege: PrivilegeModel = {
  name: 'All',
  key: 'all',
  permissions: AllPermissions,
}

export const AllPrivileges = [
  CorePrivilege,
  AgencyPrivilege,
  BrandPrivilege,
  InternalPrivilege,
  AllPrivilege,
]
